function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
var _excluded = ["view", "size", "shape", "isHover", "iconPosition", "icon"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { IconSvg } from '../IconSvg';
import { Preloader } from '../Preloader';
import { Container, Inner, Icon, ButtonCover, ButtonLinkCover, IconCenterWrapper, iconSvg, buttonCover } from './styles';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export var Button = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _props$view = props.view,
    view = _props$view === void 0 ? 'primary' : _props$view,
    _props$size = props.size,
    size = _props$size === void 0 ? 'M' : _props$size,
    _props$shape = props.shape,
    shape = _props$shape === void 0 ? 'default' : _props$shape,
    _props$isHover = props.isHover,
    isHover = _props$isHover === void 0 ? true : _props$isHover,
    _props$iconPosition = props.iconPosition,
    iconPosition = _props$iconPosition === void 0 ? 'left' : _props$iconPosition,
    icon = props.icon,
    other = _objectWithoutProperties(props, _excluded);
  var defineComponent = function defineComponent() {
    if (props.as) return props.as;
    if (props.href || props.to) return 'a';
    return undefined;
  };
  var defineType = function defineType() {
    if (!props.to && !props.href && !props.as || props.as === 'button') return 'button';
    return undefined;
  };
  var defineView = function defineView() {
    if (props.isDisabled) return 'disabled';
    if (props.isSuccess) return 'success-dim';
    return view;
  };
  return _jsxs(Container, _objectSpread(_objectSpread({
    ref: ref,
    as: defineComponent(),
    href: props.to,
    type: defineType(),
    view: defineView(),
    size: size,
    shape: shape,
    disabled: props.isDisabled || props.isLoading,
    isHover: isHover
  }, other), {}, {
    children: [_jsx(Inner, {
      isHidden: props.isLoading || props.isSuccess,
      children: _jsxs(_Fragment, {
        children: [icon && (iconPosition === 'left' || iconPosition === 'left-auto') && _jsx(Icon, {
          position: iconPosition,
          children: icon
        }), props.children, icon && (iconPosition === 'right' || iconPosition === 'right-auto') && _jsx(Icon, {
          position: iconPosition,
          children: icon
        })]
      })
    }), props.isSuccess && !props.isLoading && _jsx(IconCenterWrapper, {
      children: _jsx(IconSvg, {
        src: "check",
        css: iconSvg
      })
    }), props.isLoading && _jsx(IconCenterWrapper, {
      children: _jsx(Preloader, {
        css: iconSvg
      })
    })]
  }));
});
export { Container as ButtonEmotion, ButtonCover, ButtonLinkCover, buttonCover };
//# sourceMappingURL=index.js.map